import { html } from '@microsoft/fast-element';
import { NatGenContainer } from './container';

export const containerTemplate = html<NatGenContainer>`
    <template>
        <section class="container" part="container">
            <slot></slot>
        </section>
    </template>
`;
